import style from './chiptextloader.module.scss'

export default function ChipTextLoader() { return <div className={style.chipBox}><div className={style.chipWave}></div></div> }
